import * as styles from '../FirstResponder.module.css';
import {
  LOCKED_RANKING_NOTE,
  LOCKED_RANKING_ORDER,
} from '../LivePreview/previewRankingPolicy';

/*
 * The locked ten-step ranking order (ranking version r2, decided 2026-09-07; constraint #8) —
 * imported unchanged from `previewRankingPolicy.ts`, never fetched, never editable. Extracted so
 * `ConnectedPolicyEditor` doesn't re-inline the block SettingsEditor.tsx (frozen, untouched)
 * already renders. Follow-up debt: SettingsEditor.tsx cannot be migrated to import this component
 * without touching a frozen fixture file — a future, separately-authorized pass could do that and
 * delete its inline copy.
 */

const RankingOrderList = () => (
  <>
    <ol className={styles.rankingList} data-testid="flp-ranking-order">
      {LOCKED_RANKING_ORDER.map((step) => (
        <li
          key={step.key}
          className={styles.rankingLocked}
          data-testid={step.unavailable ? 'flp-preferred-pool-row' : undefined}
        >
          {step.label}
          {step.note ? (
            step.unavailable ? (
              <>
                {' — '}
                <em>{step.note}</em>
              </>
            ) : (
              <>
                {' '}
                <em>({step.note})</em>
              </>
            )
          ) : null}
        </li>
      ))}
    </ol>
    <div
      className={`${styles.muted} ${styles.small}`}
      style={{ marginTop: 8 }}
      data-testid="flp-ranking-locked-note"
    >
      {LOCKED_RANKING_NOTE}
    </div>
  </>
);

export default RankingOrderList;
